export class ReportConfig {
    private _reportCode?: string;

    constructor(reportCode: string) {
        this._reportCode = reportCode;
    }

    get reportCode() {
        return this._reportCode;
    }
}
